import { UserManager, WebStorageStateStore } from "oidc-client-ts";

const authority = import.meta.env.VITE_AUTHENTIK_AUTHORITY;
const client_id = import.meta.env.VITE_AUTHENTIK_CLIENT_ID;
const redirect_uri = import.meta.env.VITE_AUTHENTIK_REDIRECT_URI;

if (!authority || !client_id || !redirect_uri) {
  throw new Error("Faltan VITE_AUTHENTIK_* en el entorno");
}

export const userManager = new UserManager({
  authority,
  client_id,
  redirect_uri,
  response_type: "code",
  scope: "openid profile email",
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // No llamar /userinfo desde el SPA: Authentik no manda CORS por default y los
  // claims que necesitamos vienen en el id_token con los scopes profile+email.
  loadUserInfo: false,
});

export async function getAccessToken(): Promise<string | null> {
  const user = await userManager.getUser();
  if (!user || user.expired) return null;
  return user.access_token;
}

export async function login(): Promise<void> {
  await userManager.signinRedirect();
}

export async function logout(): Promise<void> {
  await userManager.removeUser();
  await userManager.signoutRedirect();
}
